/**
 * Country flag emojis for national teams (World Cup etc.).
 *
 * National team name → ISO-3166 alpha-2 → regional-indicator emoji.
 * England & Scotland use the special UK-subdivision flag emojis (they have no
 * regional-indicator code). Club teams aren't countries → teamFlag returns ''
 * and callers simply render no flag.
 */

const NAME_TO_ISO: Record<string, string> = {
  Algeria: 'DZ', Argentina: 'AR', Australia: 'AU', Austria: 'AT', Belgium: 'BE',
  'Bosnia & Herzegovina': 'BA', Brazil: 'BR', Canada: 'CA', 'Cape Verde': 'CV',
  Colombia: 'CO', Croatia: 'HR', 'Curaçao': 'CW', 'Czech Republic': 'CZ',
  'DR Congo': 'CD', Ecuador: 'EC', Egypt: 'EG', France: 'FR', Germany: 'DE',
  Ghana: 'GH', Haiti: 'HT', Iran: 'IR', Iraq: 'IQ', 'Ivory Coast': 'CI',
  Japan: 'JP', Jordan: 'JO', Mexico: 'MX', Morocco: 'MA', Netherlands: 'NL',
  'New Zealand': 'NZ', Norway: 'NO', Panama: 'PA', Paraguay: 'PY', Portugal: 'PT',
  Qatar: 'QA', 'Saudi Arabia': 'SA', Senegal: 'SN', 'South Africa': 'ZA',
  'South Korea': 'KR', Spain: 'ES', Sweden: 'SE', Switzerland: 'CH',
  Tunisia: 'TN', Turkey: 'TR', USA: 'US', Uruguay: 'UY', Uzbekistan: 'UZ',
  // common extras / alternative names the feed may use
  'United States': 'US', 'Korea Republic': 'KR', 'Côte d\'Ivoire': 'CI',
  'Czechia': 'CZ', Wales: 'GB', Italy: 'IT', Poland: 'PL', Denmark: 'DK',
  Serbia: 'RS', Nigeria: 'NG', Cameroon: 'CM', Chile: 'CL', Peru: 'PE',
};

// UK subdivisions — no regional-indicator code, use the tag-sequence flags.
const SPECIAL: Record<string, string> = {
  England: '\u{1F3F4}\u{E0067}\u{E0062}\u{E0065}\u{E006E}\u{E0067}\u{E007F}',
  Scotland: '\u{1F3F4}\u{E0067}\u{E0062}\u{E0073}\u{E0063}\u{E0074}\u{E007F}',
  Wales: '\u{1F3F4}\u{E0067}\u{E0062}\u{E0077}\u{E006C}\u{E0073}\u{E007F}',
};

function isoToEmoji(iso: string): string {
  return iso
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65));
}

/** Return a flag emoji for a national team, or '' for clubs / unknown names. */
export function teamFlag(name: string): string {
  if (!name) return '';
  if (SPECIAL[name]) return SPECIAL[name];
  const iso = NAME_TO_ISO[name];
  return iso ? isoToEmoji(iso) : '';
}
